import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);
let listZh = [
  {
    id: "1",
    postName: "总经理助理",
    postDuty: {
      name: "岗位职责",
      duty: [
        "1、协助并陪同总经理处理与美国保险公司、医疗机构、药房等合作，单位的业务交流、谈判、维护;",
        "2、协助总经理建设并管理好客户服务团队和业务团队; ",
        "3、协助总经理做好与美国、中国各分公司业务部门的沟通互动、业务协同，以及总经理安排的其他工作。"
      ]
    },
    dutyRequest: {
      name: "岗位要求",
      request: [
        "1、美国本科及以上学历;从事医健或健康保险相关领域，3年以上相关行政或业务管理经验;精通英文(口语必须好)和办公室软件；",
        "2、认同春华健康的服务理念,拥有符合岗位要求的学习与工作经历,愿意接受长期且持续的继续教育,有较强的服务意识、沟通能力和执行力,较好的英语沟通阅读能力。"
      ]
    }
  },
  {
    id: "2",
    postName: "全科医生",
    postDuty: {
      name: "岗位职责",
      duty: [
        "1、探索“互联网+家庭医学”在全科医学领域的运用；",
        "2、制定并实践全科诊疗规范与服务流程; ",
        "3、实施线上线下相结合的全科诊疗；",
        "4、参与集预防、疾病诊治、慢病管理、康复为一体的全流程服务；",
        "5、主导会员的健康管理、健康教育与效果评价。"
      ]
    },
    dutyRequest: {
      name: "岗位要求",
      request: [
        "1、临床医学专业本科及以上学历;",
        "2、主治医师及以上职称或规范化住院医生培训后3年,持有效执业医师资格证书；",
        "3、二级医院全科、急诊或内科工作3年以上,或一二线城市主要社区卫生服务中心工作3年以上；",
        "4、认同春华健康的服务理念,拥有符合岗位要求的学习与工作经历,愿意接受长期且持续的继续教育,有较强的服务意识、沟通能力和执行力,较好的英语沟通阅读能力。"
      ]
    }
  },
  {
    id: "3",
    postName: "心理医生",
    postDuty: {
      name: "岗位职责",
      duty: [
        "1、熟练掌握心理咨询、心理治疗相关方面的专业知识,提供系统的专业培训；",
        "2、通过电话或者网络等为客户提供心理咨询、测试、团体心理辅导,制定心理治疗计划,并指导实施; ",
        "3、对客户的心理成长、人格发展、智力、社会化及家庭、婚姻生活事件等进行全面评估,概括心理和生理测查。"
      ]
    },
    dutyRequest: {
      name: "岗位要求",
      request: [
        "1、教育学或应用心理学本科以上学历;",
        "2、心理咨询工作经验2年以上；",
        "3、具备很强的沟通力和学习力;较强的分析判断、组织协调和解决复杂问题的能力；",
        "4、需持有国家心理咨询师,医疗室,催眠师,AC国际注册心理咨询师等资质。"
      ]
    }
  },
  {
    id: "4",
    postName: "自媒体运营",
    postDuty: {
      name: "岗位职责",
      duty: [
        "1、负责微博、微信等自媒体的运营、推广,根据公司阶段性发展计划策划并执行线上营销活动;",
        "2、负责微博、微信等自媒体的内容发布、粉丝互动话题制造、活动执行; ",
        "3、了解CRM,根据粉丝会员相关数据策划互动率较高的营销活动及软文;",
        "4、根据事实热点撰写软文同时发布信息;",
        "5、建立有效运营手段提升网友活跃度,增加粉丝数,提高关注度;",
        "6、跟踪微博、微信推广效果,分析数据并反馈,分享微博推广经验。"
      ]
    },
    dutyRequest: {
      name: "岗位要求",
      request: [
        "1、本科及以上学历,具有1年或以上微博、微信运营等相关工作经验,良好美工基础;",
        "2、扎实的文字功底,头脑灵活,熟悉微博、微信运营、口碑营销、PR炒作、论坛SNS营销、SEO,有成功微博、微信运营经验者优先;",
        "3、对微博、网媒、自媒体、手机终端等新媒体运作有一定了解,对热点事件、新闻动态等信息敏感、把握能力强，能及时组织话言在微博、微信做出响应。",
        "4、有良好的团队协作精神和创新能力；",
        "5、热爱微博、微信等其他网络媒体。"
      ]
    }
  }
];
let listEn = [
  {
    id: "1",
    postName: "Assistant of the Manager",
    postDuty: {
      name: "Responsibilities of the position",
      duty: [
        "1.\tAssist and accompany the manager to make corporation with American insurance companies," +
          " medical institutions, and pharmacies; communicate, negotiate and maintain at the workplace;",
        "2.\tAssist the manager to build and manage the customer service team and the business team;",
        "3.\tAssist the manager to make communication and connection with all branches in China and the U.S." +
          " accompany during work time, and make arrangement of other work for the manager."
      ]
    },
    dutyRequest: {
      name: "Requirements to get this position",
      request: [
        "1．\tObtained a bachelor’s degree or above in the United States.; has been in the medical or health insurance field; " +
          "was in the administration office or has dealt with business management for 3 years or above; must have a good command in " +
          "English (especially the speaking part) and office software;",
        "2．\tAgrees with the service value of CHG INC.; has a matching study and work experience; " +
          "wishes to get long-term and constitutive education; has a strong sense of service, communication skills and implement," +
          " and excellent ability to read and commute in English. "
      ]
    }
  },
  {
    id: "2",
    postName: "General Practitioners",
    postDuty: {
      name: "Responsibilities of the position",
      duty: [
        "1.\tExplore the application of “internet + familial medicine” in the field of all medical courses;",
        "2.\tCreate and practice diagnosis and treatment guidelines and service processes;",
        "3.\tPractice online and offline general diagnosis and treatment;",
        "4.\tTake part in whole process service combining preventing, chronical disease management, and recovery; ",
        "5.\tGuide VIP’s health management, health education, and evaluation."
      ]
    },
    dutyRequest: {
      name: "Requirements to get the position",
      request: [
        "1.\tHas a bachelor’s degree and above in clinical medicine;;",
        "2.\tHas the title of “physician in charge” or above or holds an effective certificate of qualification" +
          " of licensed doctor after 3 years of training of standardized resident doctor;",
        "3.\tWorked at the general, emergency, or internal department at a second-grade hospital or at major " +
          "community health service centers in first and second-tier cities for 3 years and above;",
        "4.\tAgrees with the service value of CHG INC.; has a matching study and work experience; wishes to get long-term and" +
          " constitutive education; has a strong sense of service, communication skills and implement, " +
          "and excellent ability to read and commute in English. "
      ]
    }
  },
  {
    id: "3",
    postName: "Psychologists",
    postDuty: {
      name: "Responsibilities of the position",
      duty: [
        "1.\tSkillfully master relative professional knowledge of psychological counseling and psychotherapy, " +
          "provide systematic professional training;",
        "2.\tProvide individual or group psychological counseling, testing, characterized psychotherapy plans on phone or online, " +
          "and guide the patients during the treatment process;",
        "3.\tFully assess the patient’s mental growth, personality development, IQ, socialization, " +
          "and family and marriage issues; summarize mental and physical examination."
      ]
    },
    dutyRequest: {
      name: "Requirements to get the job",
      request: [
        "1.\tHas a bachelor’s degree and above in Education or Applied Psychology;",
        "2.\tHas 2 years of work experience of psychological counseling;",
        "3.\tHas strong communication skills and learning ability; has an excellent ability to analyze," +
          " judge, organize, adjust, and solve complicated problems;",
        "4.\tHoldMore Exclusive Services a certificate of national psychological consult, physician," +
          " hypnotist, and AC international registered psychological consultant qualification."
      ]
    }
  },
  {
    id: "4",
    postName: "We Media Operations",
    postDuty: {
      name: "Responsibilities of the position",
      duty: [
        "1.\tBe responsible for the operation and promotion of we media such as Weibo and Wechat;" +
          " plan and carry out online sale activities according to CHG INC’s stage development;",
        "2.\tBe responsible for content publishing, creation of fan interaction topics, and implementation of activities; ",
        "3.\tKnow about CRM, plan high interaction rate activities and advertising articles according to fan VIP’s relative data;",
        "4.\tPublish information while composing advertising articles according to facts and hot news;",
        "5.\tIncrease online activity, increases the number of fans and improve popularity using efficient operation skills;",
        "6.\tTrack the advertising effects of Weibo and wechat; analyze the data and give feedback, and share advertising experience on Weibo."
      ]
    },
    dutyRequest: {
      name: "Requirements to get the job",
      request: [
        "1.\tHas a bachelor’s degree or above, and has one year of relative work experience of Weibo and Wechat operation, and good art designing skills;",
        "2.\tHas excellent writing skills; is flexible, familiar with Weibo and wechat operation, WOMMA, PR speculation, forum SNS marketing, and SEO;" +
          " people with successful experience of operating Weibo and Wechat first;",
        "3.\tHas certain knowledge about new media such as Weibo, internet media, we media, and mobile terminal; " +
          "is sensitive to information like hot events and news; has a strong ability to grasp important information, " +
          "organize the information, respond to what happens on Weibo and Wechat, and communicate after."
        // "4、有良好的团队协作精神和创新能力；",
        // "5、热爱微博、微信等其他网络媒体。"
      ]
    }
  }
];
export default new Vuex.Store({
  state: {
    list: listZh,
    logInStatus: false
  },
  mutations: {
    chinese(state) {
      state.list = listZh;
    },
    english(state) {
      state.list = listEn;
    },
    changeLogInStatus(state, value) {
      state.logInStatus = value;
    }
  },
  actions: {
    changeChinese(ctx, value) {
      ctx.commit("chinese", value);
    },
    changeEnglish(ctx, value) {
      ctx.commit("english", value);
    },
    changeLogInStatus(ctx, value) {
      ctx.commit("changeLogInStatus", value);
    }
  }
});
